"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _proptypes = require("../utils/proptypes");

var _uid = require("../utils/uid");

var _styles = require("../styles");

var _Result = _interopRequireDefault(require("./Result"));

var _locale = require("../locale");

var _OptionList = _interopRequireDefault(require("./OptionList"));

var _OptionTree = _interopRequireDefault(require("./OptionTree"));

var _BoxList = _interopRequireDefault(require("./BoxList"));

var _is = require("../utils/is");

var _document = require("../utils/dom/document");

var _element = require("../utils/dom/element");

var _AbsoluteList = _interopRequireDefault(require("../List/AbsoluteList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var WrappedOptionList = (0, _AbsoluteList.default)(_OptionList.default);
var WrappedBoxList = (0, _AbsoluteList.default)(_BoxList.default);
var WrappedOptionTree = (0, _AbsoluteList.default)(_OptionTree.default);

var Select =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Select, _PureComponent);

  function Select(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {
      control: 'mouse',
      focus: false,
      position: 'drop-down'
    };
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindOptionFunc = _this.bindOptionFunc.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setInputReset = _this.setInputReset.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.shouldFocus = _this.shouldFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleBlur = _this.handleState.bind(_assertThisInitialized(_assertThisInitialized(_this)), false);
    _this.handleClear = _this.handleClear.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleRemove = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)), false);
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleInputFocus = _this.handleInputFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleControlChange = _this.handleControlChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClickAway = _this.handleClickAway.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleInputBlur = _this.handleInputBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.renderItem = _this.renderItem.bind(_assertThisInitialized(_assertThisInitialized(_this))); // option list not render till first focused

    _this.renderPending = true;
    _this.optionList = {};
    _this.selectId = "select_" + (0, _uid.getUidStr)();
    _this.closeByResult = false;
    _this.mouseDown = false;
    _this.isOptionList = false;
    _this.lastResult = undefined;
    return _this;
  }

  var _proto = Select.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var onFilter = this.props.onFilter; // clear filter

    if (prevState.focus !== this.state.focus && !this.state.focus && onFilter) {
      setTimeout(function () {
        onFilter('');
      }, 400);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.clearClickAway();
  };

  _proto.getText = function getText(key) {
    return this.props.text[key] || (0, _locale.getLocale)(key);
  };

  _proto.setInputReset = function setInputReset(fn) {
    this.inputReset = fn;
  };

  _proto.isDescendent = function isDescendent(el, id) {
    var stay = el.classList.contains((0, _styles.selectClass)('input')) || el.classList.contains((0, _styles.selectClass)('item'));
    if (stay) this.optionsHold = true;

    if (el.classList.contains((0, _styles.selectClass)('result')) && this.optionsHold === null && this.state.focus) {
      this.closeByResult = true;
      this.optionsHold = false;
    }

    if (el.getAttribute('data-id') === id) return typeof this.optionsHold === 'boolean' ? this.optionsHold : true;
    if (!el.parentElement) return false;
    return this.isDescendent(el.parentElement, id);
  };

  _proto.bindOptionFunc = function bindOptionFunc(name, fn) {
    this.optionList[name] = fn;
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.bindClickAway = function bindClickAway() {
    document.addEventListener('click', this.handleClickAway, true);
  };

  _proto.clearClickAway = function clearClickAway() {
    document.removeEventListener('click', this.handleClickAway, true);
  };

  _proto.handleClickAway = function handleClickAway(e) {
    this.optionsHold = null;
    var desc = this.isDescendent(e.target, this.selectId);

    if (!desc) {
      if (!(0, _element.getParent)(e.target, "[data-id=" + this.selectId + "]")) {
        this.props.onBlur();
        this.clearClickAway();
      }

      this.handleState(false, null);
    }
  };

  _proto.handleClick = function handleClick(e) {
    if (this.closeByResult) {
      this.closeByResult = false;
      return;
    }

    this.handleState(true, e);
  };

  _proto.handleState = function handleState(focus, e) {
    if (this.props.disabled === true) return;
    if (focus === this.state.focus) return; // click close icon

    if (focus && e && e.target.classList.contains((0, _styles.selectClass)('close'))) return;
    var height = this.props.height;
    var position = this.props.position;
    var windowHeight = _document.docSize.height;
    var bottom = height + this.element.getBoundingClientRect().bottom;
    if (bottom > windowHeight && !position) position = 'drop-up';
    this.setState({
      focus: focus,
      position: position || 'drop-down'
    });

    if (focus) {
      this.renderPending = false;
    }
  };

  _proto.handleControlChange = function handleControlChange(control) {
    if (control !== this.state.control) this.setState({
      control: control
    });
  };

  _proto.handleChange = function handleChange(_, data, fromInput) {
    var _this2 = this;

    var _this$props = this.props,
        datum = _this$props.datum,
        multiple = _this$props.multiple,
        disabled = _this$props.disabled;
    if (disabled === true) return; // if click option, ignore blur event

    if (this.inputBlurTimer) {
      this.lastChangeIsOptionClick = true;
      clearTimeout(this.inputBlurTimer);
    }

    if (multiple) {
      if ((0, _is.isObject)(data) && data.IS_NOT_MATCHED_VALUE) {
        datum.remove(data);
      } else {
        var checked = !datum.check(data);

        if (checked) {
          datum.add(data);
        } else {
          if (fromInput === true) return;
          datum.remove(data);
        }

        if (this.inputReset) this.inputReset();
      }
    } else {
      datum.set(data);
      this.handleState(false); //  let the element focus

      setTimeout(function () {
        return _this2.element.focus();
      }, 10);
    }
  };

  _proto.shouldFocus = function shouldFocus(el) {
    if (el.getAttribute('data-id') === this.selectId) return true;
    if ((0, _element.getParent)(el, "." + (0, _styles.selectClass)('result'))) return true;
    return false;
  };

  _proto.handleFocus = function handleFocus(e) {
    if (!this.shouldFocus(e.target)) return;
    this.props.onFocus(e);
    this.bindClickAway();
  };

  _proto.handleInputFocus = function handleInputFocus() {
    this.inputLocked = true;

    if (this.props.inputable && this.state.control === 'keyboard') {
      if (this.optionList.handleHover) this.optionList.handleHover(0, true);
    }
  };

  _proto.handleInputBlur = function handleInputBlur(text) {
    var _this3 = this;

    var _this$props2 = this.props,
        onCreate = _this$props2.onCreate,
        multiple = _this$props2.multiple;
    if (!onCreate) return;
    if (multiple && !text) return;
    if (this.lastChangeIsOptionClick) return; // if click option, ignore input blur

    this.inputBlurTimer = setTimeout(function () {
      var data = onCreate(text);

      _this3.handleChange(null, data, true);
    }, 200);
  };

  _proto.handleClear = function handleClear() {
    this.props.datum.setValue([]);
    this.element.focus();

    if (this.state.focus === false) {
      this.forceUpdate();
    } else {
      this.handleState(false);
    }
  };

  _proto.handleEnter = function handleEnter() {
    var hoverIndex = this.optionList.getIndex && this.optionList.getIndex();
    var data = this.props.data[hoverIndex];

    if (data) {
      var checked = !this.props.datum.check(data);
      this.handleChange(checked, data);
      if (this.optionList.handleHover) this.optionList.handleHover(hoverIndex);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(e) {
    this.keyLocked = true; // just for enter to open the list

    if ((e.keyCode === 13 || e.keyCode === 40) && !this.state.focus) {
      e.preventDefault();
      this.handleClick(e);
      return;
    } // fot close the list


    if (e.keyCode === 9) {
      this.props.onBlur(e); // e.preventDefault()

      if (this.state.focus) this.handleState(false, e);else this.clearClickAway();
      return;
    } // no focus no event


    if (!this.state.focus) return;
    this.handleControlChange('keyboard');

    switch (e.keyCode) {
      case 38:
        if (this.optionList.hoverMove) this.optionList.hoverMove(-1);
        e.preventDefault();
        break;

      case 40:
        if (this.optionList.hoverMove) this.optionList.hoverMove(1);
        e.preventDefault();
        break;

      case 13:
        this.handleEnter();
        e.preventDefault();
        e.stopPropagation();
        break;

      default:
        this.lastChangeIsOptionClick = false;
    }
  };

  _proto.handleKeyUp = function handleKeyUp() {
    this.keyLocked = false;
  };

  _proto.renderItem = function renderItem(data, index) {
    var renderItem = this.props.renderItem;
    return typeof renderItem === 'function' ? renderItem(data, index) : data[renderItem];
  };

  _proto.renderTree = function renderTree() {
    var _this4 = this;

    var _this$state = this.state,
        focus = _this$state.focus,
        position = _this$state.position;
    var props = {};
    ['treeData', 'expanded', 'datum', 'keygen', 'multiple', 'text', 'height', 'loading', 'onFilter', 'filterText', 'absolute', 'zIndex'].forEach(function (k) {
      props[k] = _this4.props[k];
    });
    props.renderItem = this.renderItem;
    return _react.default.createElement(WrappedOptionTree, _extends({
      onChange: this.handleChange,
      parentElement: this.element,
      position: position,
      rootClass: (0, _styles.selectClass)(position),
      selectId: this.selectId,
      focus: focus,
      renderPending: this.renderPending,
      fixed: "min"
    }, props));
  };

  _proto.renderList = function renderList() {
    var _this5 = this;

    var _this$state2 = this.state,
        focus = _this$state2.focus,
        control = _this$state2.control,
        position = _this$state2.position;
    var autoAdapt = this.props.autoAdapt;
    var props = {};
    ['data', 'datum', 'keygen', 'multiple', 'columns', 'columnWidth', 'text', 'itemsInView', 'absolute', 'lineHeight', 'height', 'loading', 'onFilter', 'filterText', 'zIndex'].forEach(function (k) {
      props[k] = _this5.props[k];
    });
    var List = props.columns > 1 ? WrappedBoxList : WrappedOptionList;
    return _react.default.createElement(List, _extends({}, props, {
      rootClass: (0, _styles.selectClass)(position),
      autoClass: (0, _styles.selectClass)(autoAdapt && 'auto-adapt'),
      bindOptionFunc: this.bindOptionFunc,
      renderPending: this.renderPending,
      focus: focus,
      control: control,
      selectId: this.selectId,
      onControlChange: this.handleControlChange,
      onChange: this.handleChange,
      renderItem: this.renderItem,
      parentElement: this.element,
      position: position,
      onBlur: this.handleBlur,
      fixed: autoAdapt ? 'min' : true
    }));
  };

  _proto.renderOptions = function renderOptions() {
    var treeData = this.props.treeData;
    if (treeData) return this.renderTree();
    return this.renderList();
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        placeholder = _this$props3.placeholder,
        multiple = _this$props3.multiple,
        clearable = _this$props3.clearable,
        disabled = _this$props3.disabled,
        size = _this$props3.size,
        onFilter = _this$props3.onFilter,
        datum = _this$props3.datum,
        filterText = _this$props3.filterText,
        onCreate = _this$props3.onCreate,
        result = _this$props3.result,
        compressed = _this$props3.compressed,
        trim = _this$props3.trim;
    var className = (0, _styles.selectClass)('inner', size, this.state.focus && 'focus', this.state.position, multiple && 'multiple', disabled === true && 'disabled');
    var renderResult = this.props.renderResult || this.renderItem;
    return _react.default.createElement("div", {
      // eslint-disable-next-line
      tabIndex: disabled === true ? -1 : 0,
      ref: this.bindElement,
      className: className,
      "data-id": this.selectId,
      onFocus: this.handleFocus,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp
    }, _react.default.createElement(_Result.default, {
      trim: trim,
      filterText: filterText,
      onClear: clearable ? this.handleClear : undefined,
      onCreate: onCreate,
      onRemove: this.handleRemove,
      onFilter: onFilter,
      datum: datum,
      disabled: disabled,
      focus: this.state.focus,
      result: result,
      multiple: multiple,
      placeholder: placeholder,
      renderResult: renderResult,
      onInputBlur: this.handleInputBlur,
      onInputFocus: this.handleInputFocus,
      setInputReset: this.setInputReset,
      compressed: compressed
    }), this.renderOptions());
  };

  return Select;
}(_component.PureComponent);

Select.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'placehodler', 'keygen'), {
  absolute: _propTypes.default.bool,
  clearable: _propTypes.default.bool,
  columns: _propTypes.default.number,
  data: _propTypes.default.array,
  treeData: _propTypes.default.array,
  datum: _propTypes.default.object.isRequired,
  disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  filterText: _propTypes.default.string,
  height: _propTypes.default.number,
  itemsInView: _propTypes.default.number,
  lineHeight: _propTypes.default.number,
  loading: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
  multiple: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onCreate: _propTypes.default.func,
  onFilter: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  position: _propTypes.default.string,
  renderItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  result: _propTypes.default.array,
  size: _propTypes.default.string,
  text: _propTypes.default.object,
  compressed: _propTypes.default.bool,
  trim: _propTypes.default.bool,
  autoAdapt: _propTypes.default.bool
});
Select.defaultProps = {
  clearable: false,
  columns: 1,
  data: [],
  height: 250,
  itemsInView: 10,
  lineHeight: 32,
  loading: false,
  multiple: false,
  renderItem: function renderItem(e) {
    return e;
  },
  text: {},
  compressed: false,
  trim: true,
  autoAdapt: false
};
var _default = Select;
exports.default = _default;